import React from "react";

// Every timing below is on the authored 7-second clock; the panel scales real time to it.
export const AUTHORED_MS = 7000;

const ease = (x) => 1 - Math.pow(1 - Math.min(1, Math.max(0, x)), 3);
const riseSm = (ms = 300) => ({ animation: `dsRiseSm ${ms}ms cubic-bezier(.22,1,.36,1) both` });
const eyebrow = { margin: 0, fontSize: 12, fontWeight: 600, color: "#8B7D91" };

const QUERY = "cloud migration services";
const TENDERS = [
  { title: "Enterprise Cloud Migration Services", meta: "Dept of Veterans Affairs · closes in 6 days", verdict: "Worth a look", tone: "#1F7D38", bg: "#F1FAF3", dot: "#2DAD4E" },
  { title: "Cybersecurity Operations Support", meta: "Dept of the Army · closes in 12 days", verdict: "Problems to resolve first", tone: "#7A5209", bg: "#FDF7EA", dot: "#D9A441" },
  { title: "Data Platform Modernization", meta: "General Services Admin · closes in 21 days", verdict: "Worth a look", tone: "#1F7D38", bg: "#F1FAF3", dot: "#2DAD4E" },
];
const FILTERS = ["NAICS 541512", "Small-business set-aside", "Closing in 30 days"];

export const FindScene = ({ t }) => {
  const typed = QUERY.slice(0, Math.floor(t / 55));
  const shown = t < 1500 ? 0 : Math.min(3, Math.floor((t - 1500) / 420) + 1);
  return (
    <div style={riseSm()}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, height: 46, padding: "0 14px", borderRadius: 12, border: "1.5px solid #8B55DD", boxShadow: "0 0 0 3px rgba(139,85,221,.12)" }}>
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#8B55DD" strokeWidth="2.2" strokeLinecap="round">
          <circle cx="11" cy="11" r="7" />
          <path d="M20 20l-3.5-3.5" />
        </svg>
        <span style={{ fontSize: 14.5, fontWeight: 500 }}>{typed}</span>
        <span className="ds-caret" style={{ width: 2, height: 18, marginLeft: -8, background: "#8B55DD", animation: "dsBlink 1s steps(1) infinite" }} />
        <span style={{ marginLeft: "auto", padding: "3px 9px", borderRadius: 999, background: "#F3EDF7", fontSize: 11, fontWeight: 600, color: "#7A45C9", whiteSpace: "nowrap" }}>
          SAM.gov · updated today
        </span>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 10 }}>
        {FILTERS.map((f) => (
          <span key={f} style={{ padding: "4px 10px", borderRadius: 999, border: "1px solid #EAE2EE", fontSize: 11.5, fontWeight: 500, color: "#52525B" }}>
            {f}
          </span>
        ))}
      </div>
      <p style={{ ...eyebrow, margin: "14px 0 8px" }}>
        {shown ? "214 open tenders match · sorted by fit" : "Searching 81,000 active opportunities…"}
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {TENDERS.slice(0, shown).map((td) => (
          <div key={td.title} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", borderRadius: 12, border: "1px solid #F0E9F2", background: "#fff", ...riseSm() }}>
            <div style={{ minWidth: 0, flex: 1 }}>
              <p style={{ margin: 0, fontSize: 14, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{td.title}</p>
              <p style={{ margin: "3px 0 0", fontSize: 12, fontWeight: 500, color: "#77707E" }}>{td.meta}</p>
            </div>
            <span style={{ flex: "none", display: "flex", alignItems: "center", gap: 6, padding: "5px 10px", borderRadius: 999, fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", color: td.tone, background: td.bg }}>
              <span style={{ width: 7, height: 7, borderRadius: "50%", background: td.dot }} />
              {td.verdict}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

const ASPECTS = [
  { name: "Technical fit", v: 88 },
  { name: "Past performance", v: 91 },
  { name: "Compliance", v: 74 },
  { name: "Staffing", v: 69 },
];
const CHECKS = [
  { text: "You qualify for the small-business set-aside", ok: true },
  { text: "Delivered 2 similar migrations for VA since 2023", ok: true },
  { text: "You'd need FedRAMP Moderate evidence in your knowledge base", ok: false },
];

export const QualifyScene = ({ t }) => {
  const score = Math.round(82 * ease((t - 300) / 1800));
  const shownChecks = t < 2400 ? 0 : Math.min(3, Math.floor((t - 2400) / 500) + 1);
  return (
    <div style={riseSm()}>
      <p style={eyebrow}>Enterprise Cloud Migration Services · Go / No-Go</p>
      <div style={{ display: "flex", gap: 24, alignItems: "center", marginTop: 14 }}>
        <div style={{ flex: "none", width: 140, height: 140, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", background: `conic-gradient(#2DAD4E 0 ${score}%,#F1EAF4 ${score}% 100%)` }}>
          <div style={{ width: 112, height: 112, borderRadius: "50%", background: "#fff", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <span style={{ fontSize: 36, fontWeight: 700, letterSpacing: "-.02em", lineHeight: 1 }}>{score}</span>
            <span style={{ marginTop: 3, fontSize: 11, fontWeight: 600, color: "#8B7D91" }}>READINESS</span>
          </div>
        </div>
        <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 11 }}>
          {ASPECTS.map((a, i) => {
            const q = ease((t - 500 - i * 180) / 1400);
            return (
              <div key={a.name}>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12.5, fontWeight: 500, color: "#52525B" }}>
                  <span>{a.name}</span>
                  <span style={{ fontWeight: 600, color: "#18101C" }}>{Math.round(a.v * q)}%</span>
                </div>
                <div style={{ position: "relative", height: 6, marginTop: 5, borderRadius: 3, background: "#F1EAF4", overflow: "hidden" }}>
                  <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, borderRadius: 3, background: "linear-gradient(90deg,#C95EBE,#8B55DD)", width: `${a.v * q}%` }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 7, marginTop: 18 }}>
        {CHECKS.slice(0, shownChecks).map((c) => (
          <div key={c.text} style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 12px", borderRadius: 10, background: "#FBF8FC", border: "1px solid #F0E9F2", fontSize: 13, fontWeight: 500, ...riseSm(260) }}>
            <span style={{ flex: "none", width: 20, height: 20, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, color: "#fff", background: c.ok ? "#2DAD4E" : "#D9A441" }}>
              {c.ok ? "✓" : "!"}
            </span>
            {c.text}
          </div>
        ))}
      </div>
    </div>
  );
};

const SECTIONS = ["Executive summary", "Understanding of need", "Technical approach", "Management plan", "Past performance"];
const PROSE =
  "We move 140 VA workloads to FedRAMP-authorised cloud in four waves, starting with low-risk systems so every migration pattern is proven before mission-critical services move. The runbooks come from our 2024 VBA migration, which finished eight weeks early.";

export const WriteScene = ({ t }) => {
  const streamN = Math.max(0, Math.floor((t - 700) / 17));
  const writingDone = streamN >= PROSE.length;
  return (
    <div style={{ ...riseSm(), display: "grid", gridTemplateColumns: "170px minmax(0,1fr)", gap: 18 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
        <p style={{ margin: "0 0 2px", fontSize: 11, fontWeight: 600, letterSpacing: ".08em", textTransform: "uppercase", color: "#A04A97" }}>Outline</p>
        {SECTIONS.map((name, i) => {
          const st = i < 2 ? "done" : i === 2 ? (writingDone ? "done" : "writing") : i === 3 && writingDone ? "writing" : "todo";
          return (
            <div
              key={name}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 9,
                padding: "8px 10px",
                borderRadius: 10,
                fontSize: 13,
                ...(st === "writing"
                  ? { background: "#F6EEF8", fontWeight: 600, color: "#18101C" }
                  : st === "done"
                  ? { fontWeight: 500, color: "#52525B" }
                  : { fontWeight: 500, color: "#B3A8B8" }),
              }}
            >
              <span
                style={{
                  flex: "none",
                  width: 16,
                  height: 16,
                  borderRadius: "50%",
                  boxSizing: "border-box",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 9,
                  color: "#fff",
                  ...(st === "done"
                    ? { background: "#A04A97" }
                    : st === "writing"
                    ? { border: "2px solid rgba(160,74,151,.3)", borderTopColor: "#A04A97", animation: "dsSpin .9s linear infinite" }
                    : { border: "1.5px solid #DCD2E0" }),
                }}
              >
                {st === "done" ? "✓" : ""}
              </span>
              {name}
            </div>
          );
        })}
      </div>
      <div style={{ padding: "16px 18px", borderRadius: 12, border: "1px solid #F0E9F2", background: "#FFFEFF", minHeight: 250 }}>
        <p style={{ margin: 0, fontSize: 11, fontWeight: 600, letterSpacing: ".08em", textTransform: "uppercase", color: "#8B7D91" }}>Section 3</p>
        <p style={{ margin: "4px 0 10px", fontSize: 17, fontWeight: 700 }}>Technical approach</p>
        <p style={{ margin: 0, fontSize: 13.5, fontWeight: 400, lineHeight: 1.6, color: "#3F3F46" }}>
          {PROSE.slice(0, streamN)}
          <span className="ds-caret" style={{ display: "inline-block", width: 7, height: 14, marginLeft: 2, verticalAlign: -2, background: "#A04A97", animation: "dsBlink 1s steps(1) infinite" }} />
        </p>
        {writingDone && (
          <div style={{ display: "inline-flex", alignItems: "center", gap: 6, marginTop: 12, padding: "5px 10px", borderRadius: 999, background: "#F3EDF7", fontSize: 11.5, fontWeight: 600, color: "#7A45C9", animation: "dsPop 240ms cubic-bezier(.22,1,.36,1) both" }}>
            Source: VBA Migration Close-out, p.12
          </div>
        )}
      </div>
    </div>
  );
};

const QUESTIONS = [
  { q: "Is data encrypted at rest and in transit?", src: "SOC 2 report §4.2", who: "PN", c: "#C95EBE" },
  { q: "Describe your incident response process.", src: "IR Policy v3", who: "JM", c: "#8B55DD" },
  { q: "Is MFA enforced for all admin access?", src: "Access Control Policy", who: "AK", c: "#F3904F" },
  { q: "Where is customer data stored?", src: "Data Residency Statement", who: "PN", c: "#C95EBE" },
];

export const AnswerScene = ({ t }) => {
  const shown = t < 500 ? 0 : Math.min(4, Math.floor((t - 500) / 700) + 1);
  const answered = 14 + Math.round(ease((t - 500) / 3500) * 10);
  return (
    <div style={riseSm()}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <p style={eyebrow}>Security questionnaire · VA Cloud Migration</p>
        <span style={{ fontSize: 12, fontWeight: 600, color: "#1F7D38" }}>{answered} / 24 answered</span>
      </div>
      <div style={{ position: "relative", height: 5, marginTop: 9, borderRadius: 3, background: "#F1EAF4", overflow: "hidden" }}>
        <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, borderRadius: 3, background: "#2DAD4E", width: `${(answered / 24) * 100}%` }} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 14 }}>
        {QUESTIONS.slice(0, shown).map((q) => (
          <div key={q.q} style={{ display: "flex", alignItems: "center", gap: 12, padding: "11px 13px", borderRadius: 12, border: "1px solid #F0E9F2", background: "#fff", ...riseSm(260) }}>
            <div style={{ minWidth: 0, flex: 1 }}>
              <p style={{ margin: 0, fontSize: 13.5, fontWeight: 600 }}>{q.q}</p>
              <p style={{ margin: "3px 0 0", fontSize: 12, fontWeight: 500, color: "#1F7D38" }}>✓ Answered from {q.src}</p>
            </div>
            <span style={{ flex: "none", width: 30, height: 30, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, color: "#fff", background: q.c }}>
              {q.who}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
